module.exports = __webpack_public_path__ + "img/about05.0114995d.png";